import React, { createContext, useState } from 'react';
import { Name } from './components/Name/Name';
import { Title } from './components/Title/Title';
import { SocialMedia } from './components/SocialMedia/SocialMedia';
import { Project } from './components/Project/Project';
import { useStyles } from './useStyles';
import { Footer } from './components/Footer/Footer';
import { AppBar, Toolbar } from '@material-ui/core';

export const LanguageContext = createContext();

function App() {
	const classes = useStyles();
	const [language, setLanguage] = useState('english');
	const handleLanguageChange = (ev) => setLanguage(ev.target.value);

	return (
		<LanguageContext.Provider value={{language}}>
			<div className={classes.App}>
				<AppBar className={classes.toolbar} style={{ flexDirection: 'row' }}>
					<Name />
					<SocialMedia onChange={handleLanguageChange} value={language} />
					
				</AppBar>
				<Toolbar />
				<Title/>
				<div className={classes.projects}>
					<Project />
				</div>
				<Footer />
			</div>
		</LanguageContext.Provider>
	);
}

export default App;
